import { Check, Sparkles } from 'lucide-react';
import { cn } from "@/lib/utils";

interface CompletionStepProps {
  projectId: string | null;
  storyId: string | null;
  projectName?: string;
  storyName?: string;
  characterName?: string;
  structureName?: string;
  beats?: any[];
}

export function CompletionStep({
  projectName,
  storyName,
  characterName,
  structureName,
  beats = []
}: CompletionStepProps) {

  const items = [
    {
      text: `Created New Story ${projectName || storyName || 'your story'}`,
      bold: true
    },
    {
      text: "character added to Story Bible",
      prefix: characterName || "New Protagonist",
      bold: true
    },
    {
      text: `${beats.length} chapters generated`,
      prefix: structureName,
      separator: " — ",
      bold: true,
      hide: !structureName || structureName === 'No Structure Selected' || beats.length === 0
    }
  ];

  const finishItems = items.filter(item => !item.hide);

  return (
    <div className="space-y-12 animate-in fade-in slide-in-from-bottom-2 duration-700 text-left flex flex-col items-start px-4">
      {/* Main Content */}
      <div className="space-y-4 w-full">
        <h1 className="text-4xl font-bold tracking-tight text-foreground font-lora">
          Ready to write!
        </h1>
        <p className="text-muted-foreground text-base leading-relaxed max-w-lg">
          Your creative workspace is built. You've laid the foundation, and it's time to bring your story to life.
        </p>
      </div>

      {/* Checklist Summary with modernized tick marks */}
      <div className="space-y-8 w-full py-2">
        {finishItems.map((item, idx) => (
          <div key={idx} className="flex items-center gap-5 group">
            <div className="relative flex-shrink-0">
              {/* Outer soft glow/ring */}
              <div className="absolute -inset-1.5 bg-primary/5 rounded-full blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* Premium Tick Mark */}
              <div className="relative h-7 w-7 rounded-full border-[1.5px] border-primary/30 flex items-center justify-center bg-background shadow-sm shadow-primary/5">
                <div className="h-5 w-5 rounded-full bg-primary/5 flex items-center justify-center">
                  <Check className="h-3 w-3 text-primary stroke-[3]" />
                </div>
              </div>
            </div>

            <p className="text-xl text-muted-foreground leading-snug tracking-tight">
              {item.prefix && (
                <span className={cn("text-foreground", item.bold && "font-bold tracking-tight")}>
                  {item.prefix}
                  {item.separator || " "}
                </span>
              )}
              {item.text}
            </p>
          </div>
        ))}
      </div>

    </div>
  );
}
